module.exports = __webpack_public_path__ + "static/media/Marc-Antoine Tremblay.c128bafd.jpg";